/**
 * Tilled Admin API
 *
 * Contact: integrations@tilled.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProductCode } from './productCode';
import { ProviderAccountStatusChangeEvent } from './providerAccountStatusChangeEvent';


export interface PaymentProvider { 
    account_id: string;
    /**
     * The first date the application was active. If an account is disabled and then re-activated this date will not change
     */
    active_at?: string;
    billing_owner: PaymentProvider.BillingOwnerEnum;
    /**
     * Time at which the object was created.
     */
    created_at: string;
    /**
     * The most recent time the account was disabled.
     */
    disabled_at?: string;
    id: string;
    /**
     * The first date the application went into review
     */
    in_review_at?: string;
    interac_provider_account?: object;
    /**
     * The provider_account id that is used for interac
     */
    interac_provider_account_id?: string;
    /**
     * Whether this PaymentProvider participates in manual batch close. Admin-managed. When true, successful charges on this provider get bundled into a Falcon Batch that the merchant can close on demand via POST /v1/batches/close.
     */
    manual_close_participation: boolean;
    payout_owner: PaymentProvider.PayoutOwnerEnum;
    pricing_active_on: string;
    product_code: ProductCode;
    product_code_id: string;
    provider: PaymentProvider.ProviderEnum;
    provider_account_id?: string;
    provider_account_status?: PaymentProvider.ProviderAccountStatusEnum;
    provider_account_status_history?: Array<ProviderAccountStatusChangeEvent>;
    rejected_at?: string;
    /**
     * The first date the application was updated
     */
    started_at?: string;
    status: PaymentProvider.StatusEnum;
    /**
     * The first date the application was submitted
     */
    submitted_at?: string;
    /**
     * The first date the application was submitted to the processor
     */
    submitted_to_processor_at?: string;
    /**
     * When surcharging stopped for this registration.  Will be `null` when surcharging is enabled or was never enabled.
     */
    surcharging_disabled_at?: string;
    /**
     * When surcharging became or will become permitted for this provider.  If this date is a future date, this is to allow for the 30-day card-brand review window after registration.  Will be `null` if the surcharging was never registered with the card brands.
     */
    surcharging_enabled_at?: string;
    /**
     * When this provider (MID) was registered with the card brands for surcharging.  Will be `null` when no surcharging registration has occurred.
     */
    surcharging_registered_at?: string;
    /**
     * Time at which the object was last updated.
     */
    updated_at: string;
    /**
     * Route this PaymentProvider\'s ProcessorApi calls to the mock impl instead of the real processor implementation for `provider`. Decouples routing from business identity — `provider` stays authoritative for capabilities / fees / onboarding / reporting, while `use_mock` swaps only the outbound processor call.  ProcessorApiFactory gates on this behind an `isProduction()` check, so an accidental production row with the flag set is a no-op — the real processor still handles the request.
     */
    use_mock: boolean;
    withdrawn_at?: string;
}
export namespace PaymentProvider {
    export type BillingOwnerEnum = 'provider' | 'tilled';
    export const BillingOwnerEnum = {
        PROVIDER: 'provider' as BillingOwnerEnum,
        TILLED: 'tilled' as BillingOwnerEnum
    };
    export type PayoutOwnerEnum = 'provider' | 'tilled';
    export const PayoutOwnerEnum = {
        PROVIDER: 'provider' as PayoutOwnerEnum,
        TILLED: 'tilled' as PayoutOwnerEnum
    };
    export type ProviderEnum = 'paysafe' | 'tsys' | 'mock' | 'valor' | 'handpoint' | 'north' | 'kort_tsys' | 'multi_pass';
    export const ProviderEnum = {
        PAYSAFE: 'paysafe' as ProviderEnum,
        TSYS: 'tsys' as ProviderEnum,
        MOCK: 'mock' as ProviderEnum,
        VALOR: 'valor' as ProviderEnum,
        HANDPOINT: 'handpoint' as ProviderEnum,
        NORTH: 'north' as ProviderEnum,
        KORT_TSYS: 'kort_tsys' as ProviderEnum,
        MULTI_PASS: 'multi_pass' as ProviderEnum
    };
    export type ProviderAccountStatusEnum = 'approved' | 'processing' | 'deferred' | 'disabled' | 'enabled' | 'pending' | 'rejected' | 'returned' | 'submitted' | 'waiting' | 'withdrawn' | 'Not Started' | 'In Process' | 'Internally Pending' | 'Externally Pending' | 'Complete' | 'Cancelled Or Declined' | 'See Status Notes' | 'Active' | 'Approved' | 'Approved - Conditional' | 'Approved - Collections' | 'Enrollment' | 'Closed' | 'Closed - Collections' | 'Closed - Risk' | 'Declined' | 'Declined - Threatmatrix' | 'Fraud' | 'Pending' | 'Withdrawn' | 'Received' | 'InReview' | 'DocumentRequested' | 'DocumentUploaded' | 'Error' | 'AWAITING_SIGNATURE' | 'APPLICATION_COMPLETE' | 'INITIATE_UNDERWRITING' | 'UNDERWRITING' | 'UNDERWRITING_PENDING' | 'UNDERWRITING_COMPLETE' | 'REJECTED' | 'PENDING_REVIEW' | 'UNDER_REVIEW' | 'INITIATE_PROVISIONING' | 'PROVISIONING' | 'PROVISIONING_COMPLETE' | 'GATEWAY_PROVISIONING' | 'ACTIVE' | 'INACTIVE';
    export const ProviderAccountStatusEnum = {
        APPROVED: 'approved' as ProviderAccountStatusEnum,
        PROCESSING: 'processing' as ProviderAccountStatusEnum,
        DEFERRED: 'deferred' as ProviderAccountStatusEnum,
        DISABLED: 'disabled' as ProviderAccountStatusEnum,
        ENABLED: 'enabled' as ProviderAccountStatusEnum,
        PENDING: 'pending' as ProviderAccountStatusEnum,
        REJECTED: 'rejected' as ProviderAccountStatusEnum,
        RETURNED: 'returned' as ProviderAccountStatusEnum,
        SUBMITTED: 'submitted' as ProviderAccountStatusEnum,
        WAITING: 'waiting' as ProviderAccountStatusEnum,
        WITHDRAWN: 'withdrawn' as ProviderAccountStatusEnum,
        NOT_STARTED: 'Not Started' as ProviderAccountStatusEnum,
        IN_PROCESS: 'In Process' as ProviderAccountStatusEnum,
        INTERNALLY_PENDING: 'Internally Pending' as ProviderAccountStatusEnum,
        EXTERNALLY_PENDING: 'Externally Pending' as ProviderAccountStatusEnum,
        COMPLETE: 'Complete' as ProviderAccountStatusEnum,
        CANCELLED_OR_DECLINED: 'Cancelled Or Declined' as ProviderAccountStatusEnum,
        SEE_STATUS_NOTES: 'See Status Notes' as ProviderAccountStatusEnum,
        ACTIVE: 'Active' as ProviderAccountStatusEnum,
        APPROVED2: 'Approved' as ProviderAccountStatusEnum,
        APPROVED___CONDITIONAL: 'Approved - Conditional' as ProviderAccountStatusEnum,
        APPROVED___COLLECTIONS: 'Approved - Collections' as ProviderAccountStatusEnum,
        ENROLLMENT: 'Enrollment' as ProviderAccountStatusEnum,
        CLOSED: 'Closed' as ProviderAccountStatusEnum,
        CLOSED___COLLECTIONS: 'Closed - Collections' as ProviderAccountStatusEnum,
        CLOSED___RISK: 'Closed - Risk' as ProviderAccountStatusEnum,
        DECLINED: 'Declined' as ProviderAccountStatusEnum,
        DECLINED___THREATMATRIX: 'Declined - Threatmatrix' as ProviderAccountStatusEnum,
        FRAUD: 'Fraud' as ProviderAccountStatusEnum,
        PENDING2: 'Pending' as ProviderAccountStatusEnum,
        WITHDRAWN2: 'Withdrawn' as ProviderAccountStatusEnum,
        RECEIVED: 'Received' as ProviderAccountStatusEnum,
        IN_REVIEW: 'InReview' as ProviderAccountStatusEnum,
        DOCUMENT_REQUESTED: 'DocumentRequested' as ProviderAccountStatusEnum,
        DOCUMENT_UPLOADED: 'DocumentUploaded' as ProviderAccountStatusEnum,
        ERROR: 'Error' as ProviderAccountStatusEnum,
        AWAITING_SIGNATURE: 'AWAITING_SIGNATURE' as ProviderAccountStatusEnum,
        APPLICATION_COMPLETE: 'APPLICATION_COMPLETE' as ProviderAccountStatusEnum,
        INITIATE_UNDERWRITING: 'INITIATE_UNDERWRITING' as ProviderAccountStatusEnum,
        UNDERWRITING: 'UNDERWRITING' as ProviderAccountStatusEnum,
        UNDERWRITING_PENDING: 'UNDERWRITING_PENDING' as ProviderAccountStatusEnum,
        UNDERWRITING_COMPLETE: 'UNDERWRITING_COMPLETE' as ProviderAccountStatusEnum,
        REJECTED2: 'REJECTED' as ProviderAccountStatusEnum,
        PENDING_REVIEW: 'PENDING_REVIEW' as ProviderAccountStatusEnum,
        UNDER_REVIEW: 'UNDER_REVIEW' as ProviderAccountStatusEnum,
        INITIATE_PROVISIONING: 'INITIATE_PROVISIONING' as ProviderAccountStatusEnum,
        PROVISIONING: 'PROVISIONING' as ProviderAccountStatusEnum,
        PROVISIONING_COMPLETE: 'PROVISIONING_COMPLETE' as ProviderAccountStatusEnum,
        GATEWAY_PROVISIONING: 'GATEWAY_PROVISIONING' as ProviderAccountStatusEnum,
        ACTIVE2: 'ACTIVE' as ProviderAccountStatusEnum,
        INACTIVE: 'INACTIVE' as ProviderAccountStatusEnum
    };
    export type StatusEnum = 'created' | 'started' | 'submitted' | 'test' | 'active' | 'disabled' | 'in_review' | 'rejected' | 'withdrawn';
    export const StatusEnum = {
        CREATED: 'created' as StatusEnum,
        STARTED: 'started' as StatusEnum,
        SUBMITTED: 'submitted' as StatusEnum,
        TEST: 'test' as StatusEnum,
        ACTIVE: 'active' as StatusEnum,
        DISABLED: 'disabled' as StatusEnum,
        IN_REVIEW: 'in_review' as StatusEnum,
        REJECTED: 'rejected' as StatusEnum,
        WITHDRAWN: 'withdrawn' as StatusEnum
    };
}


